export const PrintDisabledText = {
  header: 'In order to print Venn output, access to Report Lab is required',
  subHeader: 'Please contact vennsales@twosigma.com to learn more',
};
